var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 272.46 298.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .arch-1 {\n        fill: none;\n        stroke-width: 33px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "208.46 167.22 208.46 201.22 272.46 151.22 208.46 101.22 208.46 135.22 133.82 135.22 133.82 167.22 208.46 167.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arch-1",
    d: "M.58,16.65c88.19-3.1,134.32,41.45,138.41,133.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arch-1",
    d: "M.58,282.22c88.19,3.1,134.32-41.45,138.41-133.66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitArrow);
export default __webpack_public_path__ + "static/media/split_arrow.b21b2306a50deed718d93fdef624ea5c.svg";
export { ForwardRef as ReactComponent };